(function () {
  var menu = document.getElementById('main-menu-content');
  var toggle = document.querySelector('.main-menu__toggle');
  if (!menu || !toggle) return;

  // Backdrop element
  var backdrop = document.createElement('div');
  backdrop.className = 'sv-menu-backdrop';
  document.body.appendChild(backdrop);

  // Watch for is-open / is-visible class changes
  var observer = new MutationObserver(function () {
    var isOpen = menu.classList.contains('is-open') && menu.classList.contains('is-visible');
    backdrop.classList.toggle('is-active', isOpen);
    document.body.classList.toggle('sv-menu-is-open', isOpen);
  });
  observer.observe(menu, { attributes: true, attributeFilter: ['class'] });

  // Close menu when backdrop is tapped
  backdrop.addEventListener('click', function () {
    if (toggle.getAttribute('aria-expanded') === 'true') {
      toggle.click();
    }
  });
})();
